module.exports = __webpack_public_path__ + "static/media/sale.abcba9a0.svg";